import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Container, Col, Card, CardBody } from "reactstrap";

import { useDispatch } from "react-redux";
import { getRolesForTables } from "../../slices/admin/thunk";
import Loading from "../../Components/Loading";
import EmployeesTable from "../../Components/Tables/EmployeesTable/EmployeesTable";
import { useCurrentUser } from "../../slices/auth/hooks";

import EditEmployeeModal from "../../Components/modals/EmployeesModal/EditEmployeeModal";
import NavTabEmployee from "../../Components/Tabs/NavTabEmployee";
import { getStatusEmployees } from "../../utils/utils";
import SearchBar from "../../Components/SearchBar/SearchBar";
import HeadersRole from "../../Components/Headers/HeadersRole";
import employeesIcon from "../../assets/images/iconsRoles/employeesIcon.svg";
import DownloadReportCSVButton from "../../Components/Buttons/DownloadReportCSVButton";
import { downloadEmployeesReport } from "../../slices/national/thunk";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable";
const DashboardNationalsEmployees = () => {
  const currentUser = useCurrentUser();
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("1");

  const [isTerminated, setIsTerminated] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [countByStatus, setCountByStatus] = useState({
    active: 0,
    terminated: 0,
    pending: 0,
  });

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsTerminated(status === "terminated");
      setIsPending(status === "pending");
      setCurrentPage(0);
    }
  };

  const [loading, setLoading] = useState(false);

  const [employees, setEmployees] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fecthRolesNational = async () => {
    try {
      setLoading(true);
      const statusEmployees = getStatusEmployees(isTerminated, isPending);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: "nationals",
          role: "employees",
          status: statusEmployees,
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      if (response.countByStatus) {
        setCountByStatus({
          active: response.countByStatus.active,
          terminated: response.countByStatus.terminated,
          pending: response.countByStatus.pending,
        });
      }
      setEmployees(response.data);
      setTotalEmployees(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fecthRolesNational();
  }, [currentPage, isTerminated, isPending, debouncedSearchTerm, dispatch]);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState({});

  const hanldeRefreshTable = () => {
    fecthRolesNational();
  };

  const handleEditClick = (employee) => {
    setSelectedEmployee(employee);
    setIsEditModalOpen(true);
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      <EditEmployeeModal
        open={isEditModalOpen}
        setOpen={setIsEditModalOpen}
        editUser={selectedEmployee}
        setUser={setSelectedEmployee}
        onRefreshTable={hanldeRefreshTable}
      />
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole role={"Employees"} icon={employeesIcon} svg={true} />
          <Card className="mb-4 pb-3">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1  align-items-center ">
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                    shouldDisplaySearchBar={true}
                  />

                  <DropdownActionsTable
                    downloadMethod={downloadEmployeesReport}
                    params={{ nationalId: currentUser.id }}
                  />
                </div>
              </div>

              <Col xl={12}>
                <div className="d-flex justify-content-between align-items-center">
                  <NavTabEmployee
                    loading={loading}
                    toggleTab={toggleTab}
                    activeTab={activeTab}
                    countByStatus={countByStatus}
                  />


                  {/* <DownloadReportCSVButton
                    downloadMethod={downloadEmployeesReport}
                    params={{ nationalId: currentUser.id }}
                  /> */}
                </div>

                <Col xl={12}>
                  <div className="table-container  position-relative">
                    {loading && <Loading />}
                    <div className="live-preview">
                      <div className="table-responsive ">
                        <EmployeesTable
                          activeTab={activeTab}
                          data={employees}
                          searchDone={searchDone}
                          searchParam={debouncedSearchTerm}
                          shouldShowImportMessage={false}
                          onRefreshTable={hanldeRefreshTable}
                          onEditClick={handleEditClick}
                          paginationProps={{
                            itemsCount: employees.length,
                            totalPages: totalPages,
                            totalItems: totalEmployees,
                            currentPage: currentPage,
                            onChangePage: handleChangePage,
                          }}
                          isTerminated={isTerminated}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardNationalsEmployees;
